import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'

@Component({
  selector: 'ddc-search-result-quiz',
  templateUrl: './ddc-search-result-quiz.component.html',
  styleUrl: './ddc-search-result-quiz.component.scss',
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcSearchResultQuizComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() quizClick = new EventEmitter<DataSearchResult>()

  onQuizClick(): void {
    this.quizClick.emit(this.result)
  }
}
